import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SunAnimation from './SunAnimation';
import { useParams } from 'react-router-dom';
import Adfit from './Adfit';

import { useLocation } from 'react-router-dom';


import TraditionGame from './TraditionGame'; // <<--- TraditionGame 추가

const UserSunPage = ({ token ,clientUuid, onOpenAccountInfo }) => {
    const [newYearSun, setNewYearSun] = useState(null);
    const [loading, setLoading] = useState(true);
    const { uuid } = useParams(); 

    const location = useLocation();


    const fetchMyNewYearSun = async () => {
        try {
          const response = await axios.get(`/users/${uuid}/newYearSun`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response.data.success) {
            const { data } = response.data;
            setNewYearSun({
            username : data.username || '',
              gauge: data.gauge || 0,
              wishes: data.wishes || [],
              supporters: data.supporters || [],
              supportedUsers: data.supportedUsers || [],
            });
          } else {
            alert('회원 정보를 가져오는데 실패했습니다');
          }
        } catch (error) {
          alert('회원 정보를 가져오는데 실패했습니다');
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {

        fetchMyNewYearSun();
      }, [location.pathname]);




    if (loading) return <p>Loading...</p>;
    if (!newYearSun) return <p>Error: Unable to fetch your New Year Sun data.</p>;
    
    const {username = '', wishes = [], gauge = 0, supporters = []  , supportedUsers=[]} = newYearSun;
    const wishText = wishes[0] || 'No wish set';
  
    // TraditionGame 콜백
    const handleTraditionSuccess = (updatedNewYearSun) => {
        setNewYearSun(updatedNewYearSun);
    };


    return (
        <div>
                <SunAnimation
                    username={username}
                    wish={wishText}
                    gauge={gauge}
                    token={token}
                    clientUuid={clientUuid}
                    interfaceUuid={uuid}
                    onTraditionSuccess={handleTraditionSuccess}
                />
        <Adfit 
        unit="DAN-kPuc0Q7F5YVx3ZoT"
        width="320"
        height="100"
        />
        </div>
    );
};

export default UserSunPage;
